import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SubRolesCreateRequestDTO,
  SubRolesDTO,
  SubRolesUpdateRequestDTO,
  SubRolesReadByUserIdRequestDTO,
  SubRolesReadByProjectIdRequestDTO,
  SubRolesReadByIdRequestDTO,
  SubRolesUpdateIsDefaultRequestDTO,
  SubRolesDeleteRequestDTO,
  SubRolesMenuList
} from './SubRoles.interface';

import { SubRoles_create, SubRoles_delete, SubRoles_readById, SubRoles_readByProjectId, SubRoles_readByRoleId, SubRoles_readByUserId, SubRoles_update, SubRoles_updateIsDefault } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class SubRolesService {

  constructor() { }

  http = inject(HttpClient);

  SubRoles_create(data: SubRolesCreateRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_create, data);
  }

  SubRoles_update(data: SubRolesUpdateRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_update, data);
  }

  SubRoles_readByUserId(data: SubRolesReadByUserIdRequestDTO): Observable<SubRolesMenuList> {
    return this.http.post<SubRolesMenuList>(SubRoles_readByUserId, data);
  }

  SubRoles_readByProjectId(data: SubRolesReadByProjectIdRequestDTO): Observable<SubRolesDTO[]> {
    return this.http.post<SubRolesDTO[]>(SubRoles_readByProjectId, data);
  }

  SubRoles_readById(data: SubRolesReadByIdRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_readById, data);
  }

  SubRoles_updateIsDefault(data: SubRolesUpdateIsDefaultRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_updateIsDefault, data);
  }

  SubRoles_delete(data: SubRolesDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SubRoles_delete, data);
  }

  SubRoles_readByRoleId(data:{roleId : number}): Observable<SubRolesMenuList> {
    return this.http.post<SubRolesMenuList>(SubRoles_readByRoleId, data);
  }
}
